import { useQuery } from '@apollo/react-hooks'
import { useMemo } from 'react'
import CONFIG_QUERY from '../../graphql/queries/config.gql'
import getDeviceInfo from '../lib/device-info'
import useDeviceFingerprint from './use-device-fingerprint'

/**
 * Config query to get all values.
 * @param {string} fetchPolicy - (Optional) Apollo fetch policy. Default is 'cache-first'.
 * @returns {Object} Configuration data and query status
 */
export const useConfig = (fetchPolicy = 'cache-first') => {
  const deviceFingerprint = useDeviceFingerprint()

  const deviceInfo = useMemo(() => ({
    ...getDeviceInfo(),
    uuid: deviceFingerprint,
    platform: 'Web'
  }), [deviceFingerprint])

  const { data, loading, error } = useQuery(CONFIG_QUERY, {
    skip: !deviceFingerprint,
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        deviceInfo
      }
    }
  })

  return {
    appConfig: data?.config || {},
    parentalRatingsData: data?.parentalRatings,
    ageGroupsData: data?.ageGroups,
    configLoading: loading,
    configError: error,
    deviceFingerprint,
    deviceInfo
  }
}
